import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid/v1';
import { Card, CardHeader, CardContent, CardActions, Divider, Button, Grid, TextField, Checkbox, Autocomplete, createFilterOptions } from '@mui/material';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import moment from 'moment';
import { Page, Header, Alert } from 'components';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { SiteList, ActionsButton, Downloads } from './components';
import { GetSites, SetSelectedSites, SyncTracker, GetTrackerLastUpdate } from '../../actions/ReportsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	sitelist: {
		marginTop: theme.spacing(6),
	},
}));

const Reports = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const sites = useSelector((state) => state.reportsReducer.sites);
	const selectedSites = useSelector((state) => state.reportsReducer.selectedSites);
	const lastUpdate = useSelector((state) => state.reportsReducer.lastUpdate);

	const _handleChange = (option) => {
		dispatch(SetSelectedSites(option));
	};

	const getData = useCallback(() => {
		dispatch(GetSites());
		dispatch(GetTrackerLastUpdate());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const _syncTracker = () => {
		dispatch(SyncTracker());
	};

	const filterOptions = createFilterOptions({
		limit: 20
	});

	return (
		<Page className={classes.root} title="Overview">
			<Header
				module="Kpis"
				view="Reports"
				actions={(
					<ActionsButton
						syncTracker={_syncTracker}
					/>
				)}
			/>
			<Alert
				className={classes.container}
				variant="info"
				onClose={() => { }}
				message={_.isUndefined(lastUpdate) ? 'Tracker last update date unavailable!' : `Tracker last update ${moment(lastUpdate).format('DD-MM-YYYY HH:mm:SS').toString()}`}
			/>
			<Card className={classes.container}>
				<CardContent>
					<Grid container spacing={1}>
						<Grid item md={3} xs={12}>
							<Autocomplete
								id="sites"
								name="sites"
								disableCloseOnSelect
								options={sites}
								value={selectedSites}
								getOptionLabel={(option) => `${option.siteId} [${option.sow}]`}
								renderInput={(params) => <TextField {...params} label="Select Sites" variant="outlined" />}
								onChange={(event, value) => { _handleChange(value); }}
								renderTags={(value, getTagProps) => value.slice(0, 2).map((option, index) => `${option.siteId} [${option.sow}]`).join(', ')}
								renderOption={(props, option, { selected }) => (
									<li {...props}>
										<Checkbox
											key={uuid()}
											icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
											checkedIcon={<CheckBoxIcon fontSize="small" />}
											style={{ marginRight: 4 }}
											checked={!!(selected || _.findWhere(selectedSites, option) !== undefined)}
										/>
										{`${option.siteId} [${option.sow}]`}
									</li>
								)}
								multiple
								filterOptions={filterOptions}
							/>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			{selectedSites.length > 0 ? <SiteList className={classes.sitelist} /> : null}
			<Downloads />
		</Page>
	);
};

export default Reports;
